import React, { useState } from 'react';

import { Layout } from '@components/Layout';
import { TextBox } from '@components/TextBox';
import { VESSEL_NAMES } from '@models/PreAlertVessel';

export const TestTextBox: React.FC = () => {
  const [text, setText] = useState('');
  const [text2, setText2] = useState('');

  return (
    <Layout title="TestTextBox">
      <div style={{ flex: 1 }}>
        <TextBox
          value={text}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setText(e.target.value)}
          withAutoComplete
          autoCompleteChoices={VESSEL_NAMES}
        />
        <TextBox
          value={text2}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setText2(e.target.value)}
        />
      </div>
    </Layout>
  );
};
